import api from "./client";

// Click to call / WhatsApp / SMS from the signed-in person's own Aircall
// (backend routes/aircall_click.py). Calls ring in their Aircall app; messages
// leave from their Aircall line and come back through the Aircall webhooks.
export const getAircallMe = () => api.get("/aircall/me");
export const aircallStartCall = (data) => api.post("/aircall/call", data);
export const aircallSendMessage = (data) => api.post("/aircall/message", data);

// One lookup per page load: the lines a person is on rarely change.
let mePromise = null;
export const getAircallMeCached = () => {
  if (!mePromise) {
    mePromise = getAircallMe()
      .then((r) => r.data || { available: false })
      .catch(() => {
        mePromise = null;
        return { available: false };
      });
  }
  return mePromise;
};
